/**
 * Стратегії для RadioGroup та Tags полів
 */

import type { IFieldConfig } from '@/Core/Contracts/UI/Form'
import type { IFieldInputStrategy } from '@/Core/Contracts/UI/IFieldInputStrategy'
import { RadioGroupInput } from '../Inputs/RadioGroupInput'
import { RadioInput } from '../Inputs/RadioInput'
import { TagsInput } from '../Inputs/TagsInput'
import { BaseFieldInputStrategy } from './BaseFieldInputStrategy'

/**
 * Стратегія для RadioGroup поля
 */
export class RadioGroupFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'radio'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return RadioGroupInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            options: fieldConfig.options || [],
            disabled: fieldConfig.disabled,
            ...fieldConfig.inputProps,
        }
    }
}

/**
 * Стратегія для Radio поля (одиночний radio button)
 */
export class RadioFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'radio-single'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return RadioInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            disabled: fieldConfig.disabled,
            ...fieldConfig.inputProps,
        }
    }
}

/**
 * Стратегія для Tags поля
 */
export class TagsFieldStrategy extends BaseFieldInputStrategy implements IFieldInputStrategy {
    getType(): string {
        return 'tags'
    }

    getInputComponent(fieldConfig: IFieldConfig): React.ComponentType<any> {
        return TagsInput
    }

    transformInputProps(fieldConfig: IFieldConfig): Record<string, any> {
        return {
            placeholder: fieldConfig.placeholder,
            disabled: fieldConfig.disabled,
            mode: 'tags',
            ...fieldConfig.inputProps,
        }
    }
}
